// ./confirmation/OtherDetailsInput.jsx
import React from "react";

const OtherDetailsInput = ({ otherDetails, onChange }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Any other notes or message to approvers?
      </label>
      <textarea
        rows={4}
        className="w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        placeholder="Optional message, special notes, or additional requirements..."
        value={otherDetails}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default OtherDetailsInput;
